import React, {useState, useEffect} from 'react'


const FallbackImage = (props) => {
  // Pull non-DOM props out before spreading onto <img>
  const { fallback, objectFit, style, src, alt, ...imgProps } = props;
  const defaultFallback = 'https://res.cloudinary.com/dammymoses/image/upload/v1654672815/avatars/avatar_wv2acz.svg';
  const fallbackSrc = fallback || defaultFallback;
  
  const [imgSrc, setImgSrc]  = useState(src)

  useEffect(() => {
      setImgSrc(src)
  }, [src])
  
  const mergedStyle = {
    ...(style && typeof style === "object" ? style : {}),
    objectFit: objectFit || style?.objectFit || "cover",
  };

  return (
    <img
      {...imgProps}
      src={imgSrc}
      alt={alt || ""}
      style={mergedStyle}
      onError={() => {
        setImgSrc(fallbackSrc);
      }}
    />
  );
}

export default FallbackImage